module.exports = __webpack_public_path__ + "img/1005_sp.c8b155da.gif";